module.exports = __webpack_public_path__ + "img/car-driving.8a03c2d5.svg";